import { Description } from './models/version-intent';

/**
 * The UI shows only the first edit description, but saving from the UI overrides all of them: the typed text becomes
 * the only entry. A blank text is kept as an entry while the user retypes, so callers must filter blank entries out
 * before saving (see isEditDescriptionValid), since the backend rejects empty descriptions.
 */
export function getFirstEditDescription(descriptions: Description[] | null | undefined): string {
	return descriptions?.[0]?.description ?? '';
}

export function replaceEditDescriptions(text: string): Description[] {
	return [{ description: text }];
}

export function isEditDescriptionValid(description: Description): boolean {
	return !!description.description?.trim();
}
